var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.wrapStyle)},[_c('c-button',_vm._b({ref:"button",style:(_vm.computedStyle)},'c-button',_vm.$props,false)),_c('c-public-reward-box',_vm._b({ref:"rewardBox"},'c-public-reward-box',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }